import { render, staticRenderFns } from "./product-select-table.vue?vue&type=template&id=601c398c&scoped=true"
import script from "./product-select-table.vue?vue&type=script&lang=js"
export * from "./product-select-table.vue?vue&type=script&lang=js"
import style0 from "./product-select-table.vue?vue&type=style&index=0&id=601c398c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c398c",
  null
  
)

export default component.exports